import { render, staticRenderFns } from "./ImageFilter.vue?vue&type=template&id=125dec8a&scoped=true"
import script from "./ImageFilter.vue?vue&type=script&lang=js"
export * from "./ImageFilter.vue?vue&type=script&lang=js"
import style0 from "./ImageFilter.vue?vue&type=style&index=0&id=125dec8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125dec8a",
  null
  
)

export default component.exports